import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getUsasClubStaffData from '@usas/ui-web/state/orgUnitStaff/GetOrgUnitStaffData';
import postUsasClubStaffData from '@usas/ui-web/state/orgUnitStaff/PostOrgUnitStaffData';
import putUsasClubStaffData from '@usas/ui-web/state/orgUnitStaff/PutOrgUnitStaffData';
import deleteUsasClubStaffData from '@usas/ui-web/state/orgUnitStaff/DeletePersonOrgRoleDurationData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const UsasClubStaffData = {
  INITIAL_STATE, getUsasClubStaffData, postUsasClubStaffData,
  putUsasClubStaffData, deleteUsasClubStaffData
};

export default UsasClubStaffData;